module.exports = __webpack_public_path__ + "img/男男.7433ae69.png";